<template>
  <div class="nav">
    <template v-if="!$store.getters.isAppstoreMode">
      <div
        class="nav-item-bg"
        :class="{
          'nav-item-bg-left': type == 'xcbf',
          'nav-item-bg-middle': type == 'ycdy',
          'nav-item-bg-right': type == 'nwct',
        }"
      ></div>
      <div class="nav-body">
        <div
          class="nav-item"
          @click="onChangeTypeClick('xcbf')"
          :class="{ active: type == 'xcbf' }"
        >
          <div class="nav-item-icon nav-item-icon-01"></div>
          <div class="nav-item-text">相册备份</div>
        </div>
        <!-- <div
          class="nav-item"
          @click="onChangeTypeClick('ycdy')"
          :class="{ active: type == 'ycdy' }"
        >
          <div class="nav-item-icon nav-item-icon-02"></div>
          <div class="nav-item-text">远程打印</div>
        </div> -->
        <div
          class="nav-item"
          @click="onChangeTypeClick('nwct')"
          :class="{ active: type == 'nwct' }"
        >
          <div class="nav-item-icon nav-item-icon-03"></div>
          <div class="nav-item-text">内网穿透</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div
        class="nav-item-bg"
        :class="{
          'nav-item-bg-left': true,
        }"
      ></div>
      <div class="nav-body">
        <div
          class="nav-item"
          @click="onChangeTypeClick('nwct')"
          :class="{ active: type == 'nwct' }"
        >
          <div class="nav-item-icon nav-item-icon-03"></div>
          <div class="nav-item-text">内网穿透</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data: function () {
    return {
      type: "xcbf",
    };
  },
  methods: {
    onChangeTypeClick: function (type) {
      this.changeType(type);
      this.jumpByType();
    },
    changeType: function (type) {
      this.type = type;
    },
    jumpByType: function () {
      let path = "/home/xcbf";
      if (this.type == "xcbf") {
        path = "/home/xcbf";
      } else if (this.type == "ycdy") {
        path = "/home/ycdy";
      } else {
        path = "/home/node";
      }
      this.$router.push({ path: path });
    },
  },
  mounted: function () {
    if (this.$store.getters.isAppstoreMode) {
      this.onChangeTypeClick("nwct");
    }
  },
};
</script>

<style lang="less" scoped>
.nav {
  width: 932px;
  height: 76px;
  background: linear-gradient(180deg, #e5ddf3 0%, #f8eeff 100%);
  background: #e8e0ff;
  margin: 0 auto;
  margin-top: 12px;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  position: relative;
  .nav-item-bg {
    width: 308px;
    width: 49.3%;
    height: 68px;
    background-color: #29439d;
    background-image: linear-gradient(
      189deg,
      #6c69fe 0%,
      #4c49ec 35.94%,
      #29439d 99.24%
    );
    box-shadow: 4px 4px 12px rgba(36, 20, 102, 0.48);
    border-radius: 8px;
    position: absolute;
    top: 4px;
    left: 4px;
    z-index: 0;
    transition: all 0.3s;
  }
  .nav-item-bg-left {
    left: 4px;
  }
  .nav-item-bg-middle {
    left: 312px;
  }
  .nav-item-bg-right {
    left: 620px;
    left: 50%;
  }
  .nav-body {
    position: absolute;
    left: 0;
    top: 0;
    z-index: 2;
    width: 100%;
    height: 100%;
  }
  .nav-item:hover {
    opacity: 0.9;
  }
  .nav-item {
    display: inline-block;
    vertical-align: top;
    width: 33.3%;
    width: 49.8%;
    text-align: center;
    cursor: pointer;

    .nav-item-icon {
      display: inline-block;
      vertical-align: top;
      height: 42px;
      width: 42px;
      background-size: 100% 100%;
      margin-top: 16px;
      margin-right: 4px;
    }
    .nav-item-icon-01 {
      background-image: url(../../assets/common/nav/nav-01.png);
    }
    .nav-item-icon-02 {
      background-image: url(../../assets/common/nav/nav-02.png);
    }
    .nav-item-icon-03 {
      background-image: url(../../assets/common/nav/nav-03.png);
    }
    .nav-item-text {
      display: inline-block;
      vertical-align: top;
      color: #574e6b;
      font-family: PingFang SC;
      font-size: 16px;
      font-style: normal;
      font-weight: 600;
      line-height: normal;
      line-height: 76px;
      width: 82px;
      text-align: left;
    }
  }
  .nav-item.active {
    .nav-item-text {
      color: #ffffff;
      font-size: 20px;
    }
    .nav-item-icon-01 {
      background-image: url(../../assets/common/nav/nav-01-active.png);
    }
    .nav-item-icon-02 {
      background-image: url(../../assets/common/nav/nav-02-active.png);
    }
    .nav-item-icon-03 {
      background-image: url(../../assets/common/nav/nav-03-active.png);
    }
  }
}
</style>